// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"99200fcb","606":"99200fcb","860":"99200fcb"}[chunkId] + ".css";
};